import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { defineProfile } from "./defaultProfile";

/**
 * Bluetokai — an external loyalty partner. Legacy **class 2**.
 *
 * A hybrid, and the reason two flags that look like they should track each other do not: the
 * apply leg asks for an OTP like Xeno's, but the VERIFY goes through the offer endpoint with a
 * flat body and answers `message: "success"` — so `requiresOtpOnApply` is Xeno's value while
 * every `verifyChannel`-adjacent field is the baseline's.
 *
 * ⚠️ Its `referenceId` arrives on the VERIFY leg, not the apply. Reading it from the apply
 * response (which carries none) stored `undefined` and left the removal unblock without an id.
 *
 * ⚠️ `offerCodeField: "couponCode"` — it mints a per-customer code per offer, and its
 * `discountCode` is the shared campaign id. The old component's offers row spelled this as its
 * one remaining `isExternalProviderC2` call, and it was the only site that had it right: every
 * row read the same `discountCode` everywhere else.
 *
 * ⚠️ `stampsExternalAuthentication: false` for the same reason as Xeno — both were covered by
 * the old `!isExternalProviderC1C2(...)` guard.
 */
export const bluetokaiProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.BLUETOKAI, {
  isExternalLoyalty: true,
  requiresCouponUnblock: true,

  offerCodeField: "couponCode",
  hasCouponModal: true,

  requiresOtpOnApply: true,
  sendsRequestId: true,

  stampsExternalAuthentication: false,
  referenceIdSource: "verify",
});
